import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const ptoRequests = (state = initialState.ptoRequests, action) => {
  switch (action.type) {
    case types.LOAD_PTOREQUEST_SUCCESS:
      return action.ptoRequests;

    case types.CREATE_PTOREQUEST_SUCCESS:
      return [...state, { ...action.ptoRequest }];

    case types.UPDATE_PTOREQUEST_SUCCESS:
      return [
        ...state.filter((exp) => exp.id !== action.ptoRequest._id),
        { ...action.ptoRequest }
      ];

    case types.DELETE_PTOREQUEST_SUCCESS:
      return [...state.filter((exp) => exp.id !== action.ptoRequestId)];

    default:
      return state;
  }
};

export const savingPtoRequest = (
  state = initialState.savingPtoRequest,
  action
) => {
  switch (action.type) {
    case types.SAVING_PTOREQUEST:
      return action.savingPtoRequest;

    default:
      return state;
  }
};

export const ptoRequest = (state = initialState.ptoRequest, action) => {
  switch (action.type) {
    case types.GET_PTOREQUEST_SUCCESS:
      return action.ptoRequest;
    case types.UPDATE_PTOREQUEST_SUCCESS:
      return action.ptoRequest;
    default:
      return state;
  }
};

export const ptoRequestToDelete = (
  state = initialState.ptoRequestToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_PTOREQUEST_ID:
      return action.ptoRequestToDelete;

    default:
      return state;
  }
};

export const ptoBalance = (state = initialState.ptoBalance, action) => {
  switch (action.type) {
    case types.LOAD_PTOSUMMARY_SUCCESS:
      return action.ptoBalance;
    default:
      return state;
  }
};
export const ptoRequestReceiptToDelete = (
  state = initialState.ptoRequestReceiptToDelete
) => state;
